/**
 * Furniture / assembly addon — parity with legacy M&H Living `assembly-addon-option` snippet.
 * Syncs hidden `items[][id]` / `items[][quantity]` into Horizon's product form so FormData
 * matches the Living theme cart/add payload when add-to-cart runs via product-form-component.
 */

/**
 * @param {HTMLElement} root
 */
function initAssemblyAddon(root) {
  if (root.dataset.assemblyAddonInitialized === 'true') return;
  root.dataset.assemblyAddonInitialized = 'true';

  const sectionId = root.dataset.sectionId;
  const blockId = root.dataset.blockId;
  const firstVariantId = root.dataset.firstVariantId;

  if (!sectionId || !blockId || !firstVariantId) return;

  /** @type {HTMLFormElement | null} */
  const form = document.querySelector(
    `product-form-component[data-section-id="${CSS.escape(sectionId)}"] form`
  );
  if (!form) return;

  const wrapperDomId = 'assembly-addon-hidden-wrapper-' + blockId;
  let hiddenWrapper = document.getElementById(wrapperDomId);
  if (!hiddenWrapper) {
    hiddenWrapper = document.createElement('div');
    hiddenWrapper.id = wrapperDomId;
    hiddenWrapper.hidden = true;
    hiddenWrapper.setAttribute('aria-hidden', 'true');
    form.appendChild(hiddenWrapper);
  }

  const checkbox = root.querySelector('[data-assembly-checkbox]');
  const variantGroup = root.querySelector('[data-assembly-variant-group]');

  function syncHiddenInputs() {
    hiddenWrapper.innerHTML = '';

    if (!(checkbox instanceof HTMLInputElement) || !checkbox.checked) return;

    let variantId = firstVariantId;
    if (variantGroup instanceof HTMLElement && variantGroup.querySelector('input[type="radio"]')) {
      const selected = variantGroup.querySelector('input[type="radio"]:checked');
      if (!(selected instanceof HTMLInputElement)) return;
      variantId = selected.value;
    }

    const inputId = document.createElement('input');
    inputId.type = 'hidden';
    inputId.name = 'items[][id]';
    inputId.value = variantId;

    const inputQty = document.createElement('input');
    inputQty.type = 'hidden';
    inputQty.name = 'items[][quantity]';
    inputQty.value = '1';

    hiddenWrapper.appendChild(inputId);
    hiddenWrapper.appendChild(inputQty);
  }

  function toggleVariantVisibility() {
    if (!(variantGroup instanceof HTMLElement)) return;
    if (!(checkbox instanceof HTMLInputElement)) return;
    variantGroup.hidden = !checkbox.checked;
  }

  checkbox?.addEventListener('change', () => {
    toggleVariantVisibility();
    syncHiddenInputs();
  });

  variantGroup?.addEventListener('change', syncHiddenInputs);

  toggleVariantVisibility();
  syncHiddenInputs();
}

function bootAssemblyAddon() {
  document.querySelectorAll('[data-assembly-addon-root]').forEach((el) => {
    if (el instanceof HTMLElement) initAssemblyAddon(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootAssemblyAddon);
} else {
  bootAssemblyAddon();
}
